export { default } from "./Company";
export { default as CompanyHeader } from "./Header";



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Company/index.js